// extracted by mini-css-extract-plugin
export var Hero = "Hero-module--Hero--jQzJT";
export var aniSpin = "Hero-module--ani-spin--hFD97";
export var carousel = "Hero-module--carousel--3mNvn";
export var container = "Hero-module--container--O-e6Y";
export var darken = "Hero-module--darken--wlU4l";
export var logo = "Hero-module--logo--8B0yB";
export var logo__wrapper = "Hero-module--logo__wrapper--67J-A";
export var parallax = "Hero-module--parallax--IpvP9";
export var spacer = "Hero-module--spacer--XJD6c";